declare global {
  interface Window {
    Intercom: any;
    intercomSettings: {
      api_base: string;
      app_id: string;
    };
  }
}

interface UserData {
  subjectIdentityId: string;
  name: string;
  nickname?: string;
  email: string;
  details?: {
    subject?: {
      createTime?: string;
    };
  };
}

const APP_ID = 'yzp59663';

class IntercomService {
  private static instance: IntercomService;
  private isScriptLoaded = false;

  private constructor() {
    // Private constructor to enforce singleton pattern
  }

  public static getInstance(): IntercomService {
    if (!IntercomService.instance) {
      IntercomService.instance = new IntercomService();
    }
    return IntercomService.instance;
  }

  private loadScript(): Promise<void> {
    if (this.isScriptLoaded) {
      return Promise.resolve();
    }

    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.async = true;
      script.src = `https://widget.intercom.io/widget/${APP_ID}`;
      
      script.onload = () => {
        this.isScriptLoaded = true;
        resolve();
      };
      
      script.onerror = () => {
        reject(new Error('Failed to load Intercom script'));
      };

      document.body.appendChild(script);

      // Initialize Intercom settings
      window.intercomSettings = {
        api_base: "https://api-iam.intercom.io",
        app_id: APP_ID
      };
    });
  }

  public async initForLoggedInUser(userData: UserData): Promise<void> {
    await this.loadScript();
    
    if (window.Intercom) {
      window.Intercom('boot', {
        app_id: APP_ID,
        user_id: userData.subjectIdentityId,
        name: userData.nickname || userData.name,
        email: userData.email,
        created_at: userData.details?.subject?.createTime 
          ? Math.floor(new Date(userData.details.subject.createTime).getTime() / 1000)
          : Math.floor(Date.now() / 1000)
      });
    }
  }

  public async initForAnonymousUser(): Promise<void> {
    await this.loadScript();
    
    if (window.Intercom) {
      window.Intercom('boot', {
        app_id: APP_ID
      });
    }
  }

  public async openMessenger(): Promise<void> {
    await this.loadScript();
    
    if (window.Intercom) {
      window.Intercom('showMessages');
    }
  }

  public shutdown(): void {
    if (window.Intercom) {
      window.Intercom('shutdown');
    }
  }
}

export const intercomService = IntercomService.getInstance(); 